import { AlertTriangle, MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui';
import { buildSupportWhatsAppUrl, SUPPORT_WHATSAPP_NUMBER } from '../CandidatePortalLayout';

const REQUEST_NEW_LINK_MESSAGE =
  "Hi, my onboarding link has expired. Could you please send me a new one?";

export const InviteExpiredPage = () => {
  return (
    <div className="card">
      <div className="card-body py-12 text-center space-y-5">
        <div className="mx-auto flex items-center justify-center h-14 w-14 rounded-full bg-amber-100">
          <AlertTriangle className="h-7 w-7 text-amber-600" />
        </div>
        <div className="space-y-2">
          <h2 className="text-lg font-semibold text-rgf-gray-900">Your onboarding link has expired</h2>
          <p className="text-sm text-rgf-gray-600 max-w-md mx-auto">
            Onboarding links are valid for a limited time and for a single candidate. Please request a
            new link from our support team and we'll send it to you on WhatsApp.
          </p>
        </div>
        <div className="flex justify-center">
          <a
            href={buildSupportWhatsAppUrl(REQUEST_NEW_LINK_MESSAGE)}
            target="_blank"
            rel="noreferrer"
          >
            <Button icon={<MessageCircle className="h-4 w-4" />}>
              Request a new link on WhatsApp
            </Button>
          </a>
        </div>
        <p className="text-xs text-rgf-gray-500">
          Or message us directly at{' '}
          <span className="font-medium text-rgf-gray-700">+91 {SUPPORT_WHATSAPP_NUMBER}</span>.
        </p>
      </div>
    </div>
  );
};
